import type { VoidFunctionComponent } from 'react';

import Button from '../../../generic/Button';
import { FormGroup, LabeledTextInput } from '../../../generic/Forms';
import type { MavenRepository } from '../../../../../typings/common';

type RepositoryProps = Pick<MavenRepository, 'id' | 'url'> & {
  onUpdateRepository: <K extends keyof MavenRepository>(
    member: K,
    value: MavenRepository[K],
  ) => void;
  onRemove: () => void;
};

/**
 * Maven settings Repository row.
 */
const Repository: VoidFunctionComponent<RepositoryProps> = ({
  id,
  url,
  onRemove,
  onUpdateRepository,
}) => (
  <div className="margin-bottom-sm">
    <FormGroup direction="row" spacing="sm" baselineAlignment>
      <LabeledTextInput
        labelVariant="legacy"
        label="ID"
        value={id || ''}
        size="small"
        onChange={value => onUpdateRepository('id', value)}
        placeholder="foo"
      />
      <LabeledTextInput
        labelVariant="legacy"
        label="URL"
        value={url || ''}
        size="small"
        onChange={value => onUpdateRepository('url', value)}
        placeholder="https://example.com/foo"
      />
      <Button
        type="error"
        size="small"
        onClick={onRemove}
      >
        Remove
      </Button>
    </FormGroup>
  </div>
);

export default Repository;
